namespace $ {
	
	export class $mol_rest_port_ws extends $mol_rest_port {}
	
}
